var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOwn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 220,
    viewBox: "0 0 200 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0H176C189.255 0 200 10.7452 200 24V196C200 209.255 189.255 220 176 220H24C10.7452 220 0 209.255 0 196V24Z",
    fill: "#E7AF43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95 65C95 62.2386 97.2386 60 100 60C102.761 60 105 62.2386 105 65V75C105 77.7614 102.761 80 100 80C97.2386 80 95 77.7614 95 75V65ZM55 105C52.2386 105 50 107.239 50 110C50 112.761 52.2386 115 55 115H65C67.7614 115 70 112.761 70 110C70 107.239 67.7614 105 65 105H55ZM135 105C132.239 105 130 107.239 130 110C130 112.761 132.239 115 135 115H145C147.761 115 150 112.761 150 110C150 107.239 147.761 105 145 105H135Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M117.536 84.6066C115.583 86.5592 115.583 89.725 117.536 91.6776C119.488 93.6302 122.654 93.6302 124.607 91.6776L131.678 84.6066C133.63 82.6539 133.63 79.4881 131.678 77.5355C129.725 75.5829 126.559 75.5829 124.607 77.5355L117.536 84.6066Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M81.6778 84.6066C83.6305 86.5592 83.6305 89.725 81.6778 91.6776C79.7252 93.6302 76.5594 93.6302 74.6068 91.6776L67.5357 84.6066C65.5831 82.6539 65.5831 79.4881 67.5357 77.5355C69.4883 75.5829 72.6542 75.5829 74.6068 77.5355L81.6778 84.6066Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M100 110C97.2386 110 95 112.239 95 115V155C95 157.761 97.2386 160 100 160C102.761 160 105 157.761 105 155V115C105 112.239 102.761 110 100 110Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 125C108.284 125 115 118.284 115 110C115 101.716 108.284 95 100 95C91.7157 95 85 101.716 85 110C85 118.284 91.7157 125 100 125Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwn);
export default __webpack_public_path__ + "static/media/own.037c4781.svg";
export { ForwardRef as ReactComponent };